import Colors from 'bit/mobiauto.web-ui-components.components.colors/colors';
import styled from 'styled-components';
import { lighten } from 'polished';
import { ButtonBase as MUIButton } from '@material-ui/core';
import { styled as withStyles } from '@material-ui/core/styles';

export const VehicleContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 12px;
`;

export const SimilarVehiclesContainer = styled.div`
  width: calc(100% - 32px);
  display: flex;
  flex-direction: column;
  background: ${lighten(0.25, Colors.stars.light)};
  border-radius: 4px;
  padding: 16px;
`;

export const AlertTitle = styled.div`
  color: #997b0f;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  gap: 8px;
`;

export const AlertDescription = styled.div`
  display: flex;
  margin-left: 32px;
  flex-direction: column;
`;

export const AlertActionButton = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonAlert = withStyles(MUIButton)({
  color: '#997b0f',
  border: '1px solid #997b0f',
  padding: '8px',
  borderRadius: '5px',
});
